import { render, staticRenderFns } from "./ModuleBrief.vue?vue&type=template&id=01bd7880&scoped=true&"
import script from "./ModuleBrief.vue?vue&type=script&lang=js&"
export * from "./ModuleBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd7880",
  null
  
)

export default component.exports